module.exports = __webpack_public_path__ + "img/image (19).598d6063.png";